import { fileUrl } from "@/lib/api";

const SIZES = { sm: "h-8 w-8 text-xs", md: "h-10 w-10 text-sm", lg: "h-16 w-16 text-lg" };

const initials = (name) =>
  (name || "?")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");

export const Avatar = ({ name, src, size = "md", testId }) => {
  const url = src ? (src.startsWith("http") ? src : fileUrl(src)) : null;
  return url ? (
    <img
      src={url}
      alt={name || "Profile photo"}
      referrerPolicy="no-referrer"
      className={`${SIZES[size]} shrink-0 rounded-full border border-slate-200 object-cover`}
      data-testid={testId}
    />
  ) : (
    <span
      className={`${SIZES[size]} flex shrink-0 items-center justify-center rounded-full bg-emerald-100 font-display font-bold text-emerald-800`}
      data-testid={testId}
    >
      {initials(name)}
    </span>
  );
};
